// extracted by mini-css-extract-plugin
export default {"lessonTitle":"transcript_lessonTitle__1+vws"};